module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-bottom-ties-remnants.4793e2fa.png";